import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from "@angular/core";
import {
  PanelAlertEntry,
  PanelFeeder
} from "../../../interfaces/panel-alerts.interface";
import { PANEL_COMMANDS } from "../../../constants/panel-alerts.constants";

/**
 * Fila de un comando dentro de la tarjeta de un equipo.
 *
 * Muestra el resultado del comando y, a la derecha, los dos indicadores del
 * diseno: la nube para la respuesta del servidor y la senal para la del
 * alimentador, cada uno con su propio tooltip.
 */
@Component({
  selector: "app-panel-command-row",
  templateUrl: "./command-row.html",
  styleUrls: ["../feeders.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PanelCommandRowComponent implements OnChanges {
  @Input() feeder: PanelFeeder;
  @Input() alert: PanelAlertEntry;
  @Input() timezone = "";

  /** Se emite para reenviar este comando al equipo. */
  @Output() retry = new EventEmitter<{ feeder: PanelFeeder; alert: PanelAlertEntry }>();

  /** El servidor acepto la peticion. */
  serverOk = true;
  /** El alimentador ya respondio. */
  feederAnswered = false;
  /** El alimentador fallo o no contesto. */
  feederFailed = false;
  /** Intentos que reporto el backend antes de darse por vencido. */
  attempts = 0;
  /** Clave i18n del nombre del comando. */
  labelKey = "";

  /**
   * Resuelve el estado de los dos indicadores y la etiqueta del comando.
   * @returns void
   */
  ngOnChanges(): void {
    if (!this.alert) {
      return;
    }
    /* El estado por comando vive en `loadings`: es lo que actualizan tanto el
       socket como el registro de frames, asi que manda sobre las banderas de
       la propia alerta, que solo cubren el fallo de comunicacion. */
    const status = this.feeder ? this.feeder.loadings[this.alert.alert] : "";

    /* La nube es por comando: solo se pone en rojo si el servidor rechazo
       este comando para este equipo, no por el estado general del equipo. */
    this.serverOk = !this.alert.server_error;
    this.feederAnswered = !!this.alert.data || status === "done";
    this.feederFailed =
      !this.feederAnswered && (status === "error" || !!this.alert.error || !!this.alert.alert_comm);
    this.attempts = this.alert.attempt_no || 0;

    const definition = PANEL_COMMANDS.find((item) => item.key === this.alert.alert);
    this.labelKey = definition ? definition.label_key : "testing.alarm-test";
  }

  /**
   * Reenvia este comando al equipo.
   * @param event Clic del boton; se detiene para que el cierre del modal por
   *   clic afuera no lo tome como externo cuando la fila se vuelve a pintar.
   */
  onRetry(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.retry.emit({ feeder: this.feeder, alert: this.alert });
  }
}
